import { SvgIcon } from '@mui/material';
import { capitalize } from 'lodash';
import { Box, IconButton, ListItemButton, Typography } from 'src/components/mui';
import { useMenuContext } from '../../context';

type Props = {
  label: string;
  offsetLeft: number;
  icon: React.ReactNode;
  onClick: () => void;
  onLock: () => void;
};

export default function MenuItem({ label, icon, offsetLeft, onClick, onLock }: Props) {
  const { rtl, colors } = useMenuContext();

  return (
    <Box position="relative">
      <ListItemButton
        sx={{
          textAlign: rtl ? 'right' : 'left',
          paddingLeft: `${offsetLeft}px`,
          '&:hover': {
            background: colors.hover
          },
          height: '40px'
        }}
        onClick={onClick}
      >
        <Typography
          lineClamp={2}
          sx={{
            maxWidth: '90%'
          }}
        >
          {capitalize(label)}
        </Typography>
      </ListItemButton>
      {icon && (
        <IconButton
          onClick={onLock}
          sx={{
            display: 'block',
            position: 'absolute',
            right: '10px',
            top: '0px'
          }}
        >
          <SvgIcon
            sx={{
              width: '32px',
              height: '32px'
            }}
          >
            {icon}
          </SvgIcon>
        </IconButton>
      )}
    </Box>
  );
}
